import Loading from 'pages/components/Loading';
import PropTypes from 'prop-types';
import React from 'react';
import { Modal, Table } from 'react-bootstrap';
import { ManageClassroomModalItem } from './ManageClassroomModal';

const ParticipantsModal = ({ showModal, setShowModal, users }) => {
  return (
    <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Partecipanti
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        {!showModal ? (
          <Loading height="200px" />
        ) : (
          <Table striped responsive>
            <tbody>
              {users.map((user, index) => (
                <ManageClassroomModalItem
                  user={user}
                  key={index}
                  showDropdown={false}
                />
              ))}
            </tbody>
          </Table>
        )}
      </Modal.Body>
    </Modal>
  );
};

ParticipantsModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  setShowModal: PropTypes.func.isRequired,
  users: PropTypes.array.isRequired
};

export default ParticipantsModal;
